// Legacy server endpoint (currently unused — kept for backward compat with RTK injectEndpoints).
// Forms now go directly to Google Apps Script via VITE_GAS_FORM_ENDPOINT (see contact-page hooks).
export const SERVER_ENDPOINT = (import.meta.env.VITE_SERVER_ENDPOINT as string | undefined) ?? '';

export const GAS_FORM_ENDPOINT = (import.meta.env.VITE_GAS_FORM_ENDPOINT as string | undefined) ?? '';
